module.exports = __webpack_public_path__ + "static/media/craftEgg.36784fc9.jpeg";